import { ConfirmDialog } from '@/components/blocks/ConfirmDialog/ConfirmDialog';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';
import { usePhrase } from '@/hooks';
import { TransactionHistory } from './TransactionHistory/TransactionHistory';

interface TransactionHistoryModalProps {
    handleClose: () => void;
    isOpen: boolean;
    transactionId?: number;
    token?: string;
}

export const TransactionHistoryModal = (props: TransactionHistoryModalProps) => {
    const { t } = usePhrase();
    return (
        <ConfirmDialog
            title={t(WALLET_PHRASES.TRANSACTION_HISTORY) as string}
            open={props.isOpen}
            handleClose={props.handleClose}
            data-testid="transactionHistoryModal"
        >
            {!!props.transactionId && (
                <TransactionHistory transactionId={props.transactionId} token={props.token} />
            )}
        </ConfirmDialog>
    );
};
